import axios from 'axios';
import config from '@/vue-caas/config/config.js';

const setupURI = config.setupApiUrl;
const sqlGroupStoreModule = {
  state: {
    sqlGroupList: [],
    queryPoolSGList: [],
    sqlGroupQueryInfoList: [],
    sqlGroupDetailList: []
  },
  mutations: {
    'SET_STORE_SQL_GROUP_LIST' (state, sqlGroupList) {
      state.sqlGroupList = sqlGroupList;
    },
    'SET_STORE_QUERY_POOL_SG_LIST' (state, queryPoolSGList) {
      state.queryPoolSGList = queryPoolSGList;
    },
    'SET_STORE_QUERY_INFO_LIST' (state, sqlGroupQueryInfoList) {
      state.sqlGroupQueryInfoList = sqlGroupQueryInfoList;
    },
    'SET_STORE_SQL_GROUP_DETAIL_LIST' (state, sqlGroupDetailList) {
      state.sqlGroupDetailList = sqlGroupDetailList;
    },
    'SET_STORE_SQL_DETAIL_LIST' (state, sqlDetailList) {
      state.sqlDetailList = sqlDetailList;
    },
  },
  actions: {
    getSQLGroupList: async ({commit}, params) => {
      try {
        const response = await axios.post(`${setupURI}/sqlGroup/list`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    getQueryPoolSGList: async ({commit}, params) => {
      try {
        const response = await axios.post(`${setupURI}/sqlGroup/content/list`, params);
        let listResult = response.data;
        for (let i = 0; i < listResult.queryPoolList.length; i++) {
          if (listResult.queryPoolList[i].sql_func_type == 'BEGIN') {
            listResult.queryPoolList[i].sql_func_nm = 'Select';
          }
          if (listResult.queryPoolList[i].sql_func_type == 'BODY') {
            listResult.queryPoolList[i].sql_func_nm = 'Execution ';
          }
          if (listResult.queryPoolList[i].sql_func_type == 'END') {
            listResult.queryPoolList[i].sql_func_nm = 'Done  ';
          }
          if (listResult.queryPoolList[i].sql_func_type == 'ERROR') {
            listResult.queryPoolList[i].sql_func_nm = 'Error   ';
          }
        }
        // console.log(listResult)
        return listResult;
      } catch (err) {
        throw err;
      }
    },
    deleteSQLGroup: async ({commit}, params) => {
      try {
        const response = await axios.post(`${setupURI}/sqlGroup/delete`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    getSQLGroupQueryInfoList: async ({commit}, params) => {
      try {
        const response = await axios.post(`${setupURI}/sqlGroup/content/infoList`, params);
        commit('SET_STORE_QUERY_INFO_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_QUERY_INFO_LIST', []);
        throw err;
      }
  },
    addSQLGroup: async ({commit}, params) => {
      try {
        const response = await axios.post(`${setupURI}/sqlGroup/insert`, params);
        commit('SET_STORE_SQL_GROUP_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_SQL_GROUP_LIST', []);
        throw err;
      }
    },
    getSQLGroupDetail: async ({commit}, params) => {
      try {
        const response = await axios.get(`${setupURI}/sqlGroup/detail/${params.sqlGroupId}`);
        commit('SET_STORE_SQL_GROUP_DETAIL_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_SQL_GROUP_DETAIL_LIST', []);
        throw err;
      }
    },
    getSQLGroupD2DDetail: async ({commit}, params) => {
      try {
        const response = await axios.get(`${setupURI}/sqlGroupD2D/detail/${params.sqlGroupId}`);
        commit('SET_STORE_SQL_GROUP_DETAIL_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_SQL_GROUP_DETAIL_LIST', []);
        throw err;
      }
    },
    modifySQLGroup: async ({commit}, params) => {
      try {
        const response = await axios.post(`${setupURI}/sqlGroup/update`, params);
        commit('SET_STORE_DBBRK_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_DBBRK_LIST', []);
        throw err;
      }
    },
    getSqlGroupDetail: async ({commit}, params) => {
      try {
        const response = await axios.get(`${setupURI}/sqlContentInfo/detail/${params.sqlGroupId}`);
        commit('SET_STORE_DBBRK_DETAIL_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_DBBRK_DETAIL_LIST', []);
        throw err;
      }
    },
    // getSQLQueryPoolList: async ({commit}, params) => {
    //   try {
    //     const response = await axios.post(`${setupURI}/dbadt/sqlContentList`, params);
    //     return response.data;
    //   } catch (err) {
    //     throw err;
    //   }
    // },
    saveSQLQueryList: async ({commit}, params) => {
      try {
        const response = await axios.post(`${setupURI}/sqlGroup/content/update`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },  
  },
  getters: {
    sqlGroupList: state => state.sqlGroupList,
    queryPoolSGList: state => state.queryPoolSGList,
    sqlGroupQueryInfoList: state => state.sqlGroupQueryInfoList,
    sqlGroupDetailList: state => state.sqlGroupDetailList
  }
};
export default sqlGroupStoreModule;